import React from "react";
import BoostContainer from "pages/Boost/components/BoostContainer";
import useSystemTheme from "@tomocredit/common-fe/utils/useSystemTheme";
import { BoostLanding } from "./BoostLanding";

const TomoBoost = () => {
  const useLightTheme = useSystemTheme() === 'light';
  return (
    <BoostContainer relative>
      <div className={`${useLightTheme ? "bg-white" : "bg-transparent"} lg:pt-24 pb-3`}>
        <BoostLanding />
      </div>
    </BoostContainer>
  );
};

export default TomoBoost;
